// extracted by mini-css-extract-plugin
module.exports = {"assignBtn":"Yt2ewStcWCCxMSd05xK23","icon":"_3CGaeSzUP-msTZxBRJTla8"};